export const useAuthDialog = () => {
  const authStore = useAuthStore()
  const accessToken = useCookie("accessToken")
  const isDialogVisible = useState("client-auth-dialog-visible", () => false)
  const returnTo = useState("client-auth-return-to", () => null)
  const isAuthenticated = computed(() => Boolean(authStore.authStore.token || accessToken.value))

  const openAuthDialog = (target = null) => {
    returnTo.value = target
    isDialogVisible.value = true
  }

  const closeAuthDialog = () => {
    isDialogVisible.value = false
  }

  return {
    isAuthenticated,
    isDialogVisible,
    returnTo,
    openAuthDialog,
    closeAuthDialog,
  }
}
